import type Stripe from 'stripe';
import { c } from '../../../contract';

const stripeWebhookResponses = {
  200: c.type<{ result: 'success' | 'skipped'; message?: string }>(),
  500: c.type<{ result: 'failed'; message?: string }>(),
};

export const stripeRouter = c.router(
  {
    stripeInvoicePaymentFailed: {
      summary: 'Stripe webhook endpoint that tracks failed invoice payments',
      method: 'POST',
      path: '/invoice-payment-failed',
      body: c.type<Stripe.Event>(),
      responses: stripeWebhookResponses,
    },
    stripeInvoicePaymentSucceeded: {
      summary: 'Stripe webhook endpoint that tracks invoice payments',
      method: 'POST',
      path: '/invoice-payment-succeeded',
      body: c.type<Stripe.Event>(),
      responses: stripeWebhookResponses,
    },
    stripeSubscriptionUpdate: {
      summary: 'Stripe webhook endpoint that tracks subscription updates',
      method: 'POST',
      path: '/subscription-update',
      body: c.type<Stripe.Event>(),
      responses: stripeWebhookResponses,
    },
    stripeSubscriptionScheduleEvent: {
      summary: 'Stripe webhook endpoint that tracks subscription schedule events',
      method: 'POST',
      path: '/subscription-schedule-event',
      body: c.type<Stripe.Event>(),
      responses: stripeWebhookResponses,
    },
    stripePaymentIntentSucceeded: {
      summary: 'Stripe webhook endpoint that tracks payment intent succeeded events',
      method: 'POST',
      path: '/payment-intent-succeeded',
      body: c.type<Stripe.Event>(),
      responses: stripeWebhookResponses,
    },
    stripeChargeRefunded: {
      summary: 'Stripe webhook endpoint that tracks charge refunded events',
      method: 'POST',
      path: '/charge-refunded',
      body: c.type<Stripe.Event>(),
      responses: stripeWebhookResponses,
    },
  },
  { pathPrefix: '/stripe' },
);
